/* eslint-disable react/jsx-props-no-spreading */
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  COLOR_GREEN,
  COLOR_PRIMARY,
  COLOR_RED,
  COLOR_GREY,
} from 'constants/colors';
import React, { forwardRef } from 'react';
import styled from 'styled-components';

export interface IProps {
  children: JSX.Element;
}

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  // variant?: keyof typeof variants;
  // size?: keyof typeof sizes;
  isLoading?: boolean;
  width?: number;
  color?: ButtonColor;
  size: ButtonSize;
} & IconProps;

const getButtonColor = (c: ButtonColor) => {
  if (c === 'grey') return COLOR_GREY;

  if (c === 'red') return COLOR_RED;

  if (c === 'green') return COLOR_GREEN;

  return COLOR_PRIMARY;
};

const getButtonSizeWidth = (s: ButtonSize) => {
  // if (s === 'xs') return '100px';

  // if (s === 'sm') return '150px';

  // if (s === 'md') return '200px';

  if (s === 'full') return '100%';

  return 'auto';
};

const getButtonSizePadding = (s: ButtonSize) => {
  if (s === 'xs') return '6px 10px';

  if (s === 'sm') return '8px 12px';

  if (s === 'md') return '10px 12px';

  return '12px 12px';
};

const StyledButton = styled.button<ButtonProps>`
  padding: ${props => getButtonSizePadding(props.size)};
  border-radius: 6px;
  width: ${props => getButtonSizeWidth(props.size)};
  background-color: ${props =>
    props.color ? getButtonColor(props.color) : COLOR_PRIMARY};

  p {
    color: ${props => props.color === 'grey' ? 'black':'#fff'};
    font-size: 15px;
  }

  svg{
    font-size: 15px;
  }
`;

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { type = 'button', isLoading = false, startIcon, endIcon, ...props },
    ref,
  ) => (
    <StyledButton ref={ref} type={type} {...props}>
      {isLoading && (
        <FontAwesomeIcon
          color="#fff"
          style={{
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 1,
            paddingBottom: 1,
          }}
          spin
          icon={faSyncAlt}
        />
      )}
      {!isLoading && startIcon}
      {!isLoading && props.children}
      {!isLoading && endIcon}
    </StyledButton>
  ),
);

Button.defaultProps = {
  isLoading: undefined,
  width: undefined,
  color: undefined,
};
export default Button;
